import { Module } from "vuex";
import { IRootState } from "@/store";

export interface IRouteState {
  name: string;
}

export enum RouteActions {
  SET_ROUTE_NAME = "SET_ROUTE_NAME",
}

export enum RouteMutations {
  CHANGE_ROUTE_NAME = "CHANGE_ROUTE_NAME",
}

export enum RouteGetters {
  GET_ROUTE_NAME = "GET_ROUTE_NAME",
}

export const route: Module<IRouteState, IRootState> = {
  actions: {
    [RouteActions.SET_ROUTE_NAME]({ commit }, payload) {
      commit(RouteMutations.CHANGE_ROUTE_NAME, payload);
    },
  },
  mutations: {
    [RouteMutations.CHANGE_ROUTE_NAME](state, status) {
      state.name = status;
    },
  },
  getters: {
    [RouteGetters.GET_ROUTE_NAME](state): string {
      return state.name;
    },
  },
  state: {
    name: "",
  },
};
